import { ownGet, ownPost, loginPost, sendReq, get } from "@/axios/http";
import Qs from "qs";

//验证码接口
// export let codeImageLink = '/authApi/common/defaultKaptcha?key='

// 获取滑块坐标
// export function getCoordinate(pageObj) {
//     return ownGet("/authApi/common/getCoordinate", pageObj);
// }

//登录验证码获取
export function validCoordinate(pageObj) {
    return ownGet("/authApi/api/welfare-auth/oauth/getImg?height=116&width=312", pageObj);
}

// 获取加密模块
export function getLoginKey(params) {
    return loginPost("/authApi/api/welfare-auth/oauth/getKey", params);
}
//修改密码根据 id
export function changePasswordById (pageObj) {
  return loginPost("/authApi/api/welfare-projects-service/passwordManage/changePasswordById", pageObj)
}
//登录
export function login(params) {
    return loginPost("/authApi/api/welfare-auth/oauth/token", params);
}
export function signLogin(params) {
    // return loginPost("/authApi/api/dev-service/login/signLogin", params);
    return loginPost("/authApi/api/out-service/login/signLogin", params);
}
export function getListByRole(params) {
    return loginPost("/authApi/api/welfare-user-center/menu/getListByRole", params);
}
//获取用户信息
export function getUserInfo(params) {
    return ownGet("/authApi/rs/login/user", params);
}
export function roleInfoList(params) {
    return ownGet("/authApi/api/welfare-projects-user-center/auth-center/roleInfo/list", params);
}
export function findUserInfoList(params) {
    return ownGet("/authApi/api/welfare-projects-user-center/user-center/user/findUserInfoList", params);
}
export function queryUserInfoByCard(params) {
    return ownGet("/authApi/api/welfare-user-center/user-center/user/queryUserInfoByCard", params);
}

//获取权限菜单
export async function getUserPermissions(params) {
    return await loginPost("/authApi/api/welfare-user-center/auth-center/menuInfo/findListByRole", params);
}

//获取权限id
export function getPermissIds(params) {
    return ownGet("/authApi/api/welfare-user-center/auth-center/menuInfo/queryUserMenu", params);
}

//获取全部菜单树
export function getAllMenuTree(params) {
    return loginPost("/authApi/api/welfare-user-center/auth-center/menuInfo/findAllList", params);
}

//获取cookie
export function getCookieByToken(params) {
    return ownPost("/processApi/gzl/org/login/singlePoint", params);
}

//退出登录
export function exit(params) {
    return ownGet('/authApi/rs/login/logout', params);
}

//获取组织架构（参数：_t=1683255562）
export function bpmGroupList(params) {
    return ownGet('/authApi/api/welfare-user-center/departManage/bpmGroupList', params);
}

//获取县团委组织架构（参数：_t=1683255562）
export function getDepartList(params) {
    return ownGet('/authApi/api/welfare-user-center/departManage/getDepartList', params);
}

//获取组织架构下的所有用户（参数：_t=1683255562&name=&pageNo=1&pageSize=10）
export function bpmOrgUser(params) {
    return ownGet('/authApi/api/welfare-user-center/departManage/bpmOrgUser', params);
}
/* ========================================================================================== */

// 门户用户注册
export async function addHelpUser(params) {
    return await sendReq({
        url: '/authApi/api/welfare-user-center/user-center/userHelp/addHelpUser',
        method: 'POST',
        data: JSON.stringify(Qs.parse(params)),
        headers: {
            "content-type": "application/json"
        }
    });
}

// 获取可选择要登录的部门,  account:xxx
export function getDeptIdsByAccount(params) {
  return ownGet('/authApi/api/welfare-user-center/userInfoManage/getDeptIdsByAccount', params);
}

// 选择部门后，切换用户部门,  deptId:xxx
export function saveUserDept(deptId) {
  return ownPost("/authApi/api/welfare-auth/oauth/saveUserDept?deptId="+deptId);
}

// 获取切换部门后的用户信息， id:xxx
export function findUserInfoById(params) {
  return ownGet('/authApi/api/welfare-service/passwordManage/findUserInfoById', params);
}

export function getMessageToken(params){
  return ownGet("/authApi/api/welfare-message/auth/getAccessTokenNoExpire", params);
}

// 身份证重复校验
export function validateManageIdCard(pageObj) {
  return get("/authApi/api/welfare-user-center/user-center/validateManage/idCard?idCard=" + pageObj);
}

// 实名认证接口
export function authentication(params) {
  return ownGet("/xmzxApi/personal/authentication", params);
}

// 同一账号添加其他身份
export async function addUserOtherIdentity(params) {
  return await sendReq({
      url: '/authApi/api/welfare-user-center/user-center/userManage/addUserOtherIdentity',
      method: 'POST',
      data: JSON.stringify(Qs.parse(params)),
      headers: {
          "content-type": "application/json"
      }
  });
}

// 用户信息更新
export async function updateUserInfo(params) {
  return await sendReq({
      url: '/authApi/api/welfare-user-center/user-center/user/updateUserInfo',
      method: 'POST',
      data: JSON.stringify(Qs.parse(params)),
      headers: {
          "content-type": "application/json"
      }
  });
}

export function modifyPasRemote(params) {
    return ownGet('/authApi/api/welfare-user-center/login/modifyPas', params);
}

export function modifyPasCard(params) {
  return ownGet('/authApi/api/welfare-user-center/login/modifyPasCard', params);
}

/* ----------------手机号登录相关--------------------- */
// 图形验证码
export function randomImage(params) {
  return ownGet('/authApi/api/welfare-auth/oauth/randomImage', params);
}

// 获取短信验证码
export function randomVerCode(params) {
  return ownGet('/authApi/api/welfare-projects-user-center/login/randomVerCode', params);
}
export function getVersionPrompt(params) {
    return ownGet('/xmzxApi/version/getVersionPrompt', params);
}

export function getApiK(params) {
    return ownGet('/xmzxApi/k/getApiK', params);
}
